import { READING_DARK_MODE_COOKIE } from '#shared/cookies'

export function useReadingMode() {
  const colorMode = useColorMode()
  const readingDarkMode = useCookie(READING_DARK_MODE_COOKIE, READING_DARK_MODE_COOKIE_OPTIONS)

  function toggle(value?: boolean) {
    const apply = async () => {
      readingDarkMode.value = value ?? !readingDarkMode.value
      colorMode.preference = readingDarkMode.value ? 'dark' : 'light'
      await nextTick()
    }

    // Fade the whole page at once instead of each element. If fade is not supported, or reduced motion is on, switch instantly
    if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches || !document.startViewTransition) {
      apply()
      return
    }

    document.startViewTransition(apply)
  }

  return {
    isDark: computed(() => readingDarkMode.value),
    toggle,
  }
}
